export const catchError = ()=>(e)=>{
        console.log(e);
        return "error";
    };
export const handle = async (res)=>{
    if (400 <= res.status && res.status < 500) return {
        kind: 'unauthorized',
        status: res.status
    };
    if (res.status >= 500) return {
        kind: 'failed',
        status: res.status
    };
    const result = await res.json();
    return {
        kind: 'result',
        status: 200,
        value: result
    };
};
export const ready = (result)=>result != 'loading' && result != 'error';
export const hasValues = (result)=>ready(result) && !result.isEmpty();
